import { User } from "./user";

export interface NotificationsConfiguration {
  noncomcontact: string;
  comcontact: string;
}

export interface EmailNotificationConfiguration {
  summary?: string;
  type: EmailNotificationType;
  emails: string[];
  inspectors: User[];
}

export enum EmailNotificationType {
  duesoon = "duesoon",
  pastdue = "pastdue"
}
